// import React from "react";
// import "../styles/banner.scss";

// // Import banner images
// import Banner1 from "../assets/banner/banner1.webp";
// import Banner2 from "../assets/banner/banner2.webp";
// import Banner3 from "../assets/banner/banner3.webp";
// import Banner4 from "../assets/banner/banner4.webp";
// import Banner5 from "../assets/banner/banner5.webp";

// export default function BannerSection() {
//   return (
//     <section className="banner__section section--padding">
//       <div className="container-fluid">
//         <div className="row gy-4">
          
//           {/* Banner 1 */}
//           <div className="col-lg-6 col-md-6 col-sm-6">
//             <div className="banner__items">
//               <a className="banner__items--thumbnail position__relative" href="/">
//                 <img
//                   className="banner__items--thumbnail__img"
//                   src={Banner1}
//                   alt="White Minimalist Combo Sofa"
//                 />
//                 <div className="banner__items--content banner1__content">
//                   <h2 className="banner__items--content__title banner1__title">
//                     White Minimalist <br /> Combo Sofa
//                   </h2>
//                 </div>
//               </a>
//             </div>
//           </div>

//           {/* Banner 2 */}
//           <div className="col-lg-6 col-md-6 col-sm-6">
//             <div className="banner__items">
//               <a className="banner__items--thumbnail position__relative" href="/">
//                 <img
//                   className="banner__items--thumbnail__img"
//                   src={Banner2}
//                   alt="Modern Stylish Single Sofa"
//                 />
//                 <div className="banner__items--content banner2__content">
//                   <h2 className="banner__items--content__title banner2__title">
//                     Modern Stylish <br /> Single Sofa
//                   </h2>
//                 </div>
//               </a>
//             </div>
//           </div>

//           {/* Banner 3 */}
//           <div className="col-lg-6 col-md-6 col-sm-6">
//             <div className="banner__items">
//               <a className="banner__items--thumbnail position__relative" href="/">
//                 <img
//                   className="banner__items--thumbnail__img"
//                   src={Banner3}
//                   alt="Larger Minimal Wooden Chair"
//                 />
//                 <div className="banner__items--content banner3__content">
//                   <h2 className="banner__items--content__title banner3__title">
//                     Larger Minimal <br /> Wooden Chair
//                   </h2>
//                 </div>
//               </a>
//             </div>
//           </div>

//           {/* Banner 4 + 5 (stacked) */}
//           <div className="col-lg-6 col-md-6 col-sm-6">
//             {/* Banner 4 */}
//             <div className="banner__items mb-4">
//               <a className="banner__items--thumbnail position__relative" href="/">
//                 <img
//                   className="banner__items--thumbnail__img"
//                   src={Banner4}
//                   alt="Family Package Sofa Set"
//                 />
//                 <div className="banner__items--content banner4__content">
//                   <h2 className="banner__items--content__title banner4__title">
//                     Family Package <br /> Sofa Set
//                   </h2>
//                 </div>
//               </a>
//             </div>

//             {/* Banner 5 */}
//             <div className="banner__items">
//               <a className="banner__items--thumbnail position__relative" href="/">
//                 <img
//                   className="banner__items--thumbnail__img"
//                   src={Banner5}
//                   alt="White Minimalist Combo Sofa"
//                 />
//                 <div className="banner__items--content banner5__content">
//                   <h2 className="banner__items--content__title banner5__title">
//                     White Minimalist <br /> Combo Sofa
//                   </h2>
//                 </div>
//               </a>
//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// }



// src/components/About.jsx
import React from 'react';
import {
  FaHandshake,
  FaStore,
  FaCheckCircle,
} from 'react-icons/fa';
import '../styles/about.scss';

// ============================================================
// Three pillars — what Artiza actually is
// ============================================================
const PILLARS = [
  {
    icon: <FaHandshake />,
    title: 'Commission custom work',
    text: 'Post a brief and get matched with vetted artisans who build exactly what you describe.',
  },
  {
    icon: <FaStore />,
    title: 'Buy ready-made pieces',
    text: 'Browse furniture and décor that artisans have already built and shipped.',
  },
  {
    icon: <FaCheckCircle />,
    title: 'Track every stage',
    text: 'Milestone updates, transparent pricing, and delivery on your terms — all in one place.',
  },
];

export default function About() {
  return (
    <section className="about-section" id="about">
      <span className="about-deco about-deco-1" />
      <span className="about-deco about-deco-2" />

      <div className="about-inner">
        {/* ============================================
            LEFT — text
           ============================================ */}
        <div className="about-text">
          <span className="about-eyebrow">About Artiza</span>

          <h2 className="about-title">
            A marketplace where <em>craft</em> meets <em>trust</em>.
          </h2>

          <p className="about-lead">
            Artiza connects you with Kenya's finest woodworkers and furniture
            makers. Whether you're commissioning a one-of-a-kind piece or
            browsing ready-made designs, every artisan is verified, every
            price is transparent, and every project is tracked from sketch
            to delivery.
          </p>

          <div className="about-meta">
            <div className="about-meta-item">
              <strong>1,200+</strong>
              <span>Verified artisans</span>
            </div>
            <div className="about-meta-item">
              <strong>4,500+</strong>
              <span>Projects delivered</span>
            </div>
            <div className="about-meta-item">
              <strong>4.8★</strong>
              <span>Average rating</span>
            </div>
          </div>
        </div>

        {/* ============================================
            RIGHT — pillars
           ============================================ */}
        <ul className="about-pillars">
          {PILLARS.map((p, i) => (
            <li key={i}>
              <span className="pillar-icon">{p.icon}</span>
              <div>
                <strong>{p.title}</strong>
                <p>{p.text}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}